// extracted by mini-css-extract-plugin
module.exports = {"slider":"SCurvePlot-module--slider--Ms6xm"};